import React from "react";
import ReactDOM from "react-dom";
import VodSeriesList from "../components/vodSeries/VodSeriesList";
import { initializeI18n } from '../localization/i18n';

window.renderVODSeries = (elementId, props) => {
    const element = document.getElementById(elementId);
    if (element) {
        initializeI18n()
            .then((i18nInstance) => {
                ReactDOM.render(<VodSeriesList props={props} />, element);
            })
            .catch(error => {
                console.error("Failed to initialize i18n before rendering VodSeries:", error);
            });
    } else {
        console.error(`Element with ID ${elementId} not found.`);
    }
}; 